import React, { useEffect, useState } from 'react';
import firebase from '../../FirebaseConfig/firebase';
import { AiFillPhone } from 'react-icons/ai';
import { MdEmail } from 'react-icons/md';
import { BiConversation } from 'react-icons/bi';
import './ContactUs.scss';
import Spinner from '../SpinnerComponent/Spinner';
import FB from 'firebase';
import Button from '../Button/Button';

const ContactUs = ({ user }) => {
    const [checkUser, setCheckUser] = useState(false);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [checkSubmit, setCheckSubmit] = useState(false);
    const [thanks, setThanks] = useState(false);

    useEffect(() => {
        if (user) {
            setCheckUser(true);
        }
        else {
            setCheckUser(false);
        }
    }, [user]);

    const handleSubmit = (e) => {
        setCheckSubmit(true);
        console.log('contactus');
        e.preventDefault();
        e.target.reset();
        const response = firebase.firestore().collection('contactus');
        const ContactForm = {
            name: name,
            email: email,
            message: message,
            submitOn: FB.firestore.FieldValue.serverTimestamp()
        };
        response.add(ContactForm).then(() => {
            setCheckSubmit(false);
            setThanks(true);
        });
    };

    return (
        <div className="ContactUs">
            <h className="contactus-heading" data-aos="fade-down">Reach&nbsp;<span className="sub-contactus-heading">Us</span></h>
            <div className="contactus-container">
                <div className="" data-aos="zoom-in-up">
                    <form onSubmit={handleSubmit}>
                        <div className="input-field-section">
                            <label className="inputfield-label my-1">Name</label>
                            <input
                                type="text"
                                className=" contactus-input"
                                id="exampleFormControlInput1"
                                placeholder="Enter your name"
                                //defaultValue={checkUser ? user.name : ''}
                                onChange={(e) => {
                                    setName(e.target.value);
                                }}
                            />
                        </div>

                        <div className="input-field-section">
                            <label className="inputfield-label my-1">Email address</label>
                            <input
                                type="email"
                                className=" contactus-input"
                                id="exampleFormControlInput1"
                                placeholder="Enter your email"
                                //defaultValue={checkUser ? user.email : ''}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                }}
                            />

                        </div>

                        <div className="input-field-section">
                            <label className="inputfield-label my-1">Your Message</label>
                            <textarea
                                className="form-control contactus-input-textarea"
                                id="exampleFormControlTextarea1"
                                rows="3"
                                placeholder="Enter your message"
                                onChange={(e) => {
                                    setMessage(e.target.value);
                                }}
                            />
                        </div>
                        <div className="contactus-btn-container mt-3">
                            <Button buttonSize='wide' buttonType='float' buttonColour='yellow'>Submit</Button>
                        </div>
                    </form>
                    {
                        checkSubmit && <div>
                            <p className="contactus-thanks">Submitting your response</p>
                        </div>
                    }

                    {
                        thanks &&
                        <p className="contactus-thanks text-center py-2">Thank you for your response. We will get back to you soon.</p>
                    }
                </div>

                <div>
                    <p className="contactus-desc px-2" data-aos="zoom-in">You can easily reach us from our social media or any other given method below. Otherwise simply put us a message using the form. We will get in touch with you as soon as possible.</p>
                    <div className="social-media-contactus">
                        <div className="socialmedia-contactus" >
                            <div className="contactUs-icon">
                                <div className="col contactus-subicon" data-aos="zoom-in" ><AiFillPhone /></div>
                            </div>
                            <div className="contactus-details " data-aos="fade-left">+94 71 630 8090</div>

                            <div className="contactUs-icon">
                                <div className="col contactus-subicon " data-aos="zoom-in" ><MdEmail /></div>
                            </div>
                            <div className="contactus-details " data-aos="fade-left">lccolombomonarch@gmail.com</div>

                            <div className="contactUs-icon">
                                <div className="col contactus-subicon" data-aos="zoom-in" ><BiConversation /></div>
                            </div>
                            <div className="contactus-details " data-aos="fade-left">Social Media</div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ContactUs;
